import Controller from "@ember/controller";

export default class UserPostsController extends Controller {}
